import gql from "graphql-tag";

export const GET_TRANSFER_AGENT_ORDERS = gql`
    query getTransferAgentOrders($tradeDateStart: GraphQLDateString, $statusIn: [TransactionStatus!]) {
        transferAgentOrders(filter: { tradeDateStart: $tradeDateStart, statusIn: $statusIn }) {
            _id
            status
            currency
            amount
            units
            isin
            carryOwnTransactionCost
            client {
                _id
                name
            }
            instrument {
                _id
                name
                longName
            }
            tradeDate
            valueDate
            transactionType
            externalId
            sourceId
            source {
                _id
                name
            }
            clientName
            clientNumber
            clientAccount
            updateTimestamp
            createTimestamp
            netPrice
            settledUnits
            settledAmount
            description
            subType
            referenceExternalId
            updateUserId
            updateUserInfo {
                _id
                name
            }
        }
    }
`;

export const GET_TRANSFER_AGENT_ORDERS_SUMMARY = gql`
    query getTransferAgentOrders($date: GraphQLDateString) {
        transferAgentOrders: transferAgentOrders(filter: { tradeDate: $date }) {
            _id
            transactionType
            currency
            amount
            units
            instrument {
                _id
                name
            }
            clientId
            createTimestamp
        }
        parties: parties(filter: { typeIn: [Fund] }) {
            _id
            name
            fundInfo {
                classes {
                    startNAVPerUnit
                    startDate
                    instrumentId
                }
            }
        }
    }
`;

export const GET_TRANSFER_AGENT_ORDER_DATA = gql`
    query getData($orderId: GraphQLObjectId!) {
        funds: parties(filter: { typeIn: [Fund] }) {
            _id
            name
            fundInfo {
                classes {
                    enabled
                    dividendPaying
                    shareClass
                    instrument {
                        _id
                        isin
                        name
                        currency
                    }
                }
            }
        }

        transferAgents: parties(filter: { typeIn: [TransferAgent] }) {
            _id
            name
        }

        order: transferAgentOrder(_id: $orderId) {
            _id
            carryOwnTransactionCost
            currency
            amount
            units
            isin
            tradeDate
            valueDate
            transactionType
            externalId
            sourceId
            clientId
            clientName
            clientNumber
            clientAccount
            status
            transactionIds
            description
            subType
            referenceExternalId
            attachments {
                fileId
                fileName
                mimeType
                updateTimestamp
            }
        }
    }
`;

export const GET_TRANSFER_AGENT_ORDER_LAST_NAV = gql`
    query getTransferAgentOrderLastNav($clientId: GraphQLObjectId) {
        navs(clientId: $clientId, lastOnly: true) {
            date
        }
    }
`;

export const QUERY_TRANSFER_AGENT_TOTAL_UNITS = gql`
    query getTransferAgentTotalUnit($filter: TransferAgentTotalUnitFilterInput, $includeVersions: Boolean = false) {
        transferAgentTotalUnits(filter: $filter) {
            _id
            isin
            totalUnits
            date
            sourceId
            source {
                _id
                name
            }
            instrument {
                _id
                name
                isin
            }
            updateTimestamp
            createTimestamp
            versions @include(if: $includeVersions)
        }
    }
`;

export const TRANSFER_AGENT_ORDERS_QUERY = gql`
    query transferAgentOrders($filter: OrderFilterInput) {
        transferAgentOrders(filter: $filter) {
            _id
            sourceId
            source {
                name
            }
        }
    }
`;

export const UPSERT_TRANSFER_AGENT_ORDERS = gql`
    mutation upsertTransferAgentOrders($input: [TransferAgentOrderInput!]!) {
        upsertTransferAgentOrders(input: $input) {
            _id
            clientId
            currency
            amount
            units
            isin
            tradeDate
            valueDate
            transactionType
            externalId
            sourceId
            clientName
            clientNumber
            clientAccount
            status
            transactionIds
            referenceExternalId
            subType
        }
    }
`;

export const UPSERT_TRANSFER_AGENT_ORDERS_FORM = gql`
    mutation upsertTransferAgentOrders($input: [TransferAgentOrderInput!]!) {
        upsert: upsertTransferAgentOrders(input: $input) {
            _id
            carryOwnTransactionCost
            currency
            amount
            units
            isin
            tradeDate
            valueDate
            transactionType
            externalId
            sourceId
            clientName
            clientNumber
            clientAccount
            status
            transactionIds
            description
            subType
            referenceExternalId
        }
    }
`;

export const UPDATE_TRANSFER_AGENT_ORDER_ATTACHMENTS = gql`
    mutation updateTransferAgentOrderAttachments($input: TransferAgentOrderAttachmentsInput!) {
        updateTransferAgentOrderAttachments(input: $input) {
            _id
            attachments {
                fileId
                fileName
                mimeType
                updateTimestamp
            }
        }
    }
`;

export const ADMIN_ACCOUNT_SWITCH_ALL = gql`
    mutation adminAccountSwitchAll(
        $input: [AccountSwitchAllInput!]!
        $tradeDate: GraphQLDateString!
        $isins: [GraphQLIsin!]!
        $dryRun: Boolean
    ) {
        adminAccountSwitchAll(input: $input, tradeDate: $tradeDate, isins: $isins, dryRun: $dryRun) {
            _id
            clientId
            clientAccount
            clientName
            clientNumber
            isin
            currency
            amount
            units
            settledUnits
            settledAmount
            tradeDate
            valueDate
            status
            transactionType
            subType
            externalId
            referenceExternalId
            sourceId
            description
            carryOwnTransactionCost
        }
    }
`;

export const UPDATE_TRANSFER_AGENT_ORDER_ATTACHMENTS_FORM = gql`
    mutation updateTransferAgentOrderAttachments($input: TransferAgentOrderAttachmentsInput!) {
        upsert: updateTransferAgentOrderAttachments(input: $input) {
            _id
        }
    }
`;
